import React from 'react';
import {StyleSheet, TextInput, View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import BasePopover from '/component/base/Popover';

const styles = StyleSheet.create({
  inputContainer: {
    marginBottom: 20,
  },
  input: {
    height: 40,
    borderColor: 'gray',
    borderWidth: 1,
  },
  buttonContainer: {
    paddingHorizontal: '25%',
  },
});

interface DummyWithInputProps {
  popoverClose: () => void;
}

const DummyWithInput: React.FC<DummyWithInputProps> = ({
  popoverClose = noop,
}) => {
  return (
    <BasePopover padded={true}>
      <View style={styles.inputContainer}>
        <TextInput
          placeholder="Text input inside popover"
          style={styles.input}
        />
      </View>
      <View style={styles.buttonContainer}>
        <Button onPress={popoverClose}>Close Popover</Button>
      </View>
    </BasePopover>
  );
};

export default DummyWithInput;
